import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner } from '../../../../../common/index.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import {
  useDeleteWorkshopMutation,
  useGetWorkshopsQuery,
} from '../../../../../../redux/services/fo_workshops.jsx';
import { useGetEventQuery } from '../../../../../../redux/services/fo_events.jsx';
import WorkshopsTable from '../../../../../common/FriOpen/Workshops/FoWorkshopsTable/WorkshopsTable.jsx';
import { useSelector } from 'react-redux';
import {
  ROLE_FRI_OPEN_ADMIN,
} from '../../../../../../utils/constants/roles.js';
import useUserHasRole from '../../../../../../hooks/useUserHasRoles.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages';

const FoWorkshopsPage = () => {
  const { eventId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth?.user);

  const isAdmin = useUserHasRole(ROLE_FRI_OPEN_ADMIN);
  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const isAuthorOfWorkshop = (workshop) =>
    Number(user?.person_id) === Number(workshop?.creator_id);

  const isLecturerOfWorkshop = (workshop) =>
    Number(user?.person_id) === Number(workshop?.lecturer_id);

  const { data: workshops, isLoading, refetch } = useGetWorkshopsQuery(eventId);
  const { data: event, isLoading: isLoadingEvent } = useGetEventQuery(eventId);
  const [deleteWorkshop, { isSuccess }] = useDeleteWorkshopMutation();
  const isArchivedEvent = Boolean(event?.archived_at);

  useEffect(() => {
    if (isSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isSuccess]);

  const handleEditClick = useCallback(
    (workshop) => {
      if (
        isAuthorOfWorkshop(workshop) ||
        isLecturerOfWorkshop(workshop) ||
        isAdmin
      ) {
        navigate(routes.cmsFoWorkshopsEdit(workshop.id));
      }
    },
    [user?.person_id, isAdmin, navigate],
  );

  return isLoading || isLoadingEvent ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={`${t('Zoznam seminárov pre FRI akciu')}${event?.name ? ` - ${event.name}` : ''}`}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
        createText={isArchivedEvent ? undefined : t('Pridať seminár')}
        createUrl={isArchivedEvent ? undefined : routes.cmsFoWorkshopsCreate(eventId)}
        permissionsBasic={'fo-workshops'}
      />
      <div style={{ margin: '10px' }}>
        <WorkshopsTable
          workshops={workshops}
          onEditClick={isArchivedEvent ? undefined : handleEditClick}
          onDelete={isArchivedEvent ? undefined : deleteWorkshop}
          onRowClick={(workshop) => {
            if (isArchivedEvent) {
              navigate(routes.cmsFoWorkshopsDetail(workshop.id));
            } else if (
              isAdmin ||
              isLecturerOfWorkshop(workshop) ||
              isAuthorOfWorkshop(workshop)
            ) {
              handleEditClick(workshop);
            } else {
              navigate(routes.cmsFoWorkshopsDetail(workshop.id));
            }
          }}
          onDetailClick={(workshop) => {
            navigate(routes.cmsFoWorkshopsDetail(workshop.id));
          }}
          onShowDatesClick={(workshop) =>
            navigate(routes.cmsFoDatesList(workshop.id))
          }
          isArchivedEvent={isArchivedEvent}
        />
      </div>
    </>
  );
};

export default FoWorkshopsPage;
